import { Children } from 'react'

export const getAppliedSlots = children =>
  Children.toArray(children)
    .map(child => child.type.slotName)
    .filter(Boolean)
